import { render, staticRenderFns } from "./widget_artificial_intelligence.vue?vue&type=template&id=ec6c63c4&scoped=true&"
import script from "./widget_artificial_intelligence.vue?vue&type=script&lang=js&"
export * from "./widget_artificial_intelligence.vue?vue&type=script&lang=js&"
import style0 from "./widget_artificial_intelligence.vue?vue&type=style&index=0&id=ec6c63c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6c63c4",
  null
  
)

export default component.exports